module.exports = __webpack_public_path__ + "img/podcast.38c7825.png";